import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarcodePipe } from './barcode.pipe';

@NgModule({
  declarations: [
    BarcodePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    BarcodePipe
  ]
})
export class PipesModule { }
